import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DSOSettingsDialogBox from './DSOSettingsDialogBox';
import RenameBucketDialogBox from '../Commons/RenameBucketDialogBox';
import DeleteBucketDialogBox from '../Commons/DeleteBucketDialogBox';
import ChangeCreditLimitDialogBox from '../Commons/ChangeCreditLimitDialogBox';
import MappedUsersDialogBox from './MappedUsersDialogBox';

import { ArrowDownIcon, EditIcon, TrashIcon, MenuIcon, DotIcon, CreditIcon, MoneyIcon, LockIcon, SettingsIcon, RefreshInventoryIcon } from './Styles/Icons';
import { RootContainer, FlexRow, FlexColumn, TitleSection, TitleRow, Title, Popover, PopoverBody, PopoverTitle, PopoverItem, NotFound, Tabs,
	Tab, Search, TableContainer, Table, TableHeader, TableHeaderRow, TableHeaderColumn, TableBody, TableRow, TableColumn, TablePagination, 
    DSOLogoContainer, DSOLogo, DSOAbbreviation, ButtonGroup, SquareButton, Note, Buckets } from './Styles/DSOPricing';
import { Theme } from '../Styles';

import { changeTile } from '../../actions/changeTile';
import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import { fetchBucketList } from '../../actions/inventoryActionsV2';
import { fetchDSOList, mapDSO } from '../../actions/dsoActions';
import { formatCurrency, abbreviateName, checkLabSeller } from '../../commons/utils';

const PopoverIds = {
	BUCKET: 'bucket',
	OPTIONS: 'options',
	SETTINGS: 'settings',
};
const DialogIds = {
	RENAME_BUCKET: 'rename-bucket',
	DELETE_BUCKET: 'delete-bucket',
	DSO_SETTINGS: 'dso-settings',
	CHANGE_CREDIT_LIMIT: 'change-credit-limit',
	MAPPED_USERS: 'mapped-users',
};
const paymentMethods = {
	bill_to_account: { name: 'Bill to Account', active: true, limit: true },
	credit_card: { name: 'Credit Card', active: false, limit: false },
};

class DSOPricing extends React.Component {
	constructor(props) {
		super(props);
		this._isMounted = false;
		this.state = {
			pageSize: 10,
			pageNumber: 0,
			itemsLoading: false,
			activeTab: 0,
			searchText: '',
			bucketPopoverItem: '',
			bucketSearchText: '',
			bucketPopoverAnchorElement: '',
			settingsPopoverItem: '',
			settingsPopoverItemName: '',
			settingsPopoverAnchorElement: '',
			optionsPopoverItem: '',
			optionsPopoverAnchorElement: '',
			renameBucketDialogOpen: false,
			deleteBucketDialogOpen: false,
			changeCreditLimitDialogOpen: false,
			dsoSettingsDialogOpen: false,
			dsoSettingsDialogData: {},
			mappedUsersDialogOpen: false,
			mappedUsersDialogData: [],
			filteredBuckets: [],
			buckets: {},
			bucketItems: this.props.bucketItems,
			dso: {},
			dsoState: this.props.dso,
		};
	}

	componentDidMount() {
		this._isMounted = true;
		if (this.props.tile !== 'DSO_PRICING') {
			this.props.changeTile('DSO_PRICING');
		}
		if (this.props.history.action === 'POP') {
			this.props.changeTile('DSO_PRICING');
		}

		let search = new URLSearchParams(this.props.location.search);
		const pageSize = parseInt(search.get('page_size'), 10);
		const pageNumber = parseInt(search.get('page_number'), 10);
		const searchText = search.get('search_text');
		this.setState({ 
			pageNumber: pageNumber - 1 || 0, 
			pageSize: pageSize || 10,
			searchText: searchText || '',
		}, 
		async () => {
			await this.fetchDSOList();
			await this.fetchBucketList();
		});
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.supplier !== this.props.supplier) {
			this.setState({ searchText: '', pageNumber: 0, pageSize: 10 }, () => {
				this.refreshInventoryData()
			});
		}
		if (
			prevState.searchText !== this.state.searchText || 
			prevState.pageNumber !== this.state.pageNumber || 
			prevState.pageSize !== this.state.pageSize
		) {
			this.fetchDSOList();
			this.updateURL();
		}
		if (JSON.stringify(this.state.bucketItems) !== JSON.stringify(this.props.bucketItems)) {
			this.setState({ bucketItems: JSON.parse(JSON.stringify(this.props.bucketItems)) }, () => {
				this.handleBucketList();
			});
		}
		if (JSON.stringify(this.state.dsoState) !== JSON.stringify(this.props.dso)) {
			this.setState({ dsoState: JSON.parse(JSON.stringify(this.props.dso)) }, () => {
				this.handleDSOList();
			});
		}
	}

	refreshInventoryData = async () => {
		this.fetchDSOList();
		this.fetchBucketList();
	}

	updateURL = () => {
		let urlParams = {};
		let { pageSize, pageNumber, searchText } = this.state;

		if (pageSize) urlParams['page_size'] = pageSize;
		if (pageNumber) urlParams['page_number'] = pageNumber + 1;
		if (searchText) urlParams['search_text'] = searchText;

		this.props.history.push({
			pathname: '/dsopricing',
			search: '?' + new URLSearchParams(urlParams),
		});
	};

	setActiveTab = (tab) => {
		this.setState({ activeTab: tab });
		if (tab === 0) {
			this.fetchDSOList();
		} else if (tab === 1) {
			// this.fetchBucketList();
		} else {
		}
	};

	handlePopoverClick = async (popoverId, event) => {
		switch (popoverId) {
			case PopoverIds.BUCKET:
				this.setState({ bucketPopoverAnchorElement: event.currentTarget });
				await this.fetchBucketList();
				break;
			case PopoverIds.OPTIONS:
				this.setState({ optionsPopoverAnchorElement: event.currentTarget });
				break;
			case PopoverIds.SETTINGS:
				this.setState({ settingsPopoverAnchorElement: event.currentTarget });
				break;
			default:
				break;
		}
	};

	handlePopoverSelect = async (popoverId, choice) => {
		switch (popoverId) {
			case PopoverIds.BUCKET:
				if (choice === 'none') {
					await this.mapDSO('unmap', choice);
				} else {
					await this.mapDSO('map', choice);
				}
				this.handlePopoverClose(popoverId);
				break;
			case PopoverIds.OPTIONS:
				if (choice === 'RENAME') {
					this.setState({ renameBucketDialogOpen: true });
				} else if (choice === 'DELETE') {
					this.setState({ deleteBucketDialogOpen: true });
				}
				break;
			case PopoverIds.SETTINGS:
				if (choice === 'EDIT_PAYMENT_OPTIONS') {
					this.setState({ dsoSettingsDialogOpen: true });
				} else if (choice === 'CHANGE_CREDIT_LIMIT') {
					this.setState({ changeCreditLimitDialogOpen: true });
				} else if (choice === 'LOCK_ACCOUNT') {
					// Under discussion
					// this.setState({changeCreditLimitDialogOpen:true})
				}
				break;
			default:
				this.handlePopoverClose(popoverId);
				break;
		}
	};

	handlePopoverClose = async (popoverId) => {
		switch (popoverId) {
			case PopoverIds.BUCKET:
				this.setState({ bucketPopoverAnchorElement: null, optionsPopoverItem: '' });
				break;
			case PopoverIds.OPTIONS:
				this.setState({ optionsPopoverAnchorElement: null, optionsPopoverItem: '' });
				break;
			case PopoverIds.SETTINGS:
				this.setState({ settingsPopoverAnchorElement: null, settingsPopoverItem: '' });
				break;
			default:
				break;
		}
	};

	handleDialogOnTrue = async (dialogId, data) => {
		switch (dialogId) {
			case DialogIds.RENAME_BUCKET:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.DELETE_BUCKET:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.CHANGE_CREDIT_LIMIT:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.DSO_SETTINGS:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.MAPPED_USERS:
				this.handleDialogOnClose(dialogId);
				break;
			default:
				break;
		}
	};

	handleDialogOnFalse = async (dialogId) => {
		switch (dialogId) {
			case DialogIds.RENAME_BUCKET:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.DELETE_BUCKET:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.CHANGE_CREDIT_LIMIT:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.DSO_SETTINGS:
				this.handleDialogOnClose(dialogId);
				break;
			case DialogIds.MAPPED_USERS:
				this.handleDialogOnClose(dialogId);
				break;
			default:
				break;
		}
	};

	handleDialogOnClose = async (dialogId) => {
		switch (dialogId) {
			case DialogIds.RENAME_BUCKET:
				this.setState({ renameBucketDialogOpen: false });
				this.handlePopoverClose(PopoverIds.OPTIONS);
				break;
			case DialogIds.DELETE_BUCKET:
				this.setState({ deleteBucketDialogOpen: false });
				this.handlePopoverClose(PopoverIds.OPTIONS);
				break;
			case DialogIds.DSO_SETTINGS:
				this.setState({ dsoSettingsDialogOpen: false, dsoSettingsDialogData: {} });
				this.handlePopoverClose(PopoverIds.SETTINGS);
				break;
			case DialogIds.CHANGE_CREDIT_LIMIT:
				this.setState({ changeCreditLimitDialogOpen: false });
				this.handlePopoverClose(PopoverIds.SETTINGS);
				break;
			case DialogIds.MAPPED_USERS:
				this.setState({ mappedUsersDialogOpen: false, mappedUsersDialogData: [] });
				break;
			default:
				break;
		}
	};

	setBucketSearchText = (text) => {
		this.setState({ bucketSearchText: text });
	};

	handleBucketSearchText = (text = '') => {
		let { buckets } = this.state;
		let newList = [];
		Object.keys(buckets).forEach((item) => {
			let bucket = buckets[item];
			if (bucket && bucket.alias && bucket.alias.toUpperCase().includes(text.toUpperCase())) newList.push(bucket.id);
		});
		this.setState({ bucketSearchText: text, filteredBuckets: newList });
	};

	fetchBucketList = async () => {
		await this.props.fetchBucketList();
		await this.handleBucketList();
	};

	handleBucketList = async () => {
		let bucketState = {};
		this.props.bucketItems.forEach((bucket, index) => {
			bucketState[bucket.id] = bucket;
		});
		if (this._isMounted) {
			this.setState({ buckets: bucketState });
		}
	};

	handleSearchText = (text = '') => {
		this.setState({ searchText: text, pageNumber: 0 });
	};

	fetchDSOList = async () => {
		let { pageNumber, pageSize, searchText } = this.state;
		await this.props.fetchDSOList(pageNumber + 1, pageSize, searchText);
		await this.handleDSOList();
	};

	handleDSOList = async () => {
		let dsoState = {};
		this.props.dso.records.forEach((item, index) => {
			if (!item.price_buckets) {
				item.price_buckets = {};
			}
			if (!item.price_buckets[this.props.supplier]) {
				item.price_buckets[this.props.supplier] = {};
			}
			if (!item.price_buckets[this.props.supplier].primary_bucket) {
				item.price_buckets[this.props.supplier].primary_bucket = null;
			}
			if (!item.price_buckets[this.props.supplier].secondary_bucket) {
				item.price_buckets[this.props.supplier].secondary_bucket = null;
			}
			dsoState[item._id] = item;
		});
		this.setState({ dso: dsoState });
	};

	mapDSO = async (action, bucket) => {
		if (bucket !== this.state.bucketPopoverItem.bucketId) {
			if (action === 'map') {
				await this.props.mapDSO(this.state.bucketPopoverItem.dsoId, action, this.state.bucketPopoverItem.source, bucket);
			} else {
				await this.props.mapDSO(this.state.bucketPopoverItem.dsoId, action, this.state.bucketPopoverItem.source, null);
			}
			await this.props.fetchBucketList();
		}
	};

	render() {
		let { activeTab, pageNumber, pageSize, searchText, renameBucketDialogOpen, deleteBucketDialogOpen, dsoSettingsDialogOpen, changeCreditLimitDialogOpen, 
			bucketPopoverAnchorElement, bucketPopoverItem, bucketSearchText, optionsPopoverAnchorElement, optionsPopoverItem, settingsPopoverAnchorElement, 
			settingsPopoverItem, settingsPopoverItemName, buckets, dso, dsoState, filteredBuckets, mappedUsersDialogData, mappedUsersDialogOpen } = this.state;
		let { supplier, disableBucketAssigning, disableBucketDelete } = this.props;

		return (
			<RootContainer>
				<Helmet>
					<title>Seller Portal | DSO Pricing</title>
				</Helmet>

				<RenameBucketDialogBox
					key={DialogIds.RENAME_BUCKET}
					open={renameBucketDialogOpen}
					bucket={optionsPopoverItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.RENAME_BUCKET);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.RENAME_BUCKET);
					}}
				/>

				<DeleteBucketDialogBox
					key={DialogIds.DELETE_BUCKET}
					open={deleteBucketDialogOpen}
					bucket={optionsPopoverItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DELETE_BUCKET);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DELETE_BUCKET);
					}}
				/>

				<ChangeCreditLimitDialogBox
					key={DialogIds.CHANGE_CREDIT_LIMIT}
					open={changeCreditLimitDialogOpen}
					dso={settingsPopoverItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.CHANGE_CREDIT_LIMIT);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.CHANGE_CREDIT_LIMIT);
					}}
				/>

				<DSOSettingsDialogBox
					key={DialogIds.DSO_SETTINGS}
					open={dsoSettingsDialogOpen}
					title={settingsPopoverItemName}
					dso={dso}
					id={settingsPopoverItem}
					onClose={() => {
						this.handleDialogOnClose(DialogIds.DSO_SETTINGS);
					}}
				/>

				<MappedUsersDialogBox
					key={DialogIds.MAPPED_USERS}
					open={mappedUsersDialogOpen}
					data={mappedUsersDialogData}
					onClose={() => {
						this.handleDialogOnClose(DialogIds.MAPPED_USERS);
					}}
				/>

				<Popover
					id={PopoverIds.OPTIONS}
					open={Boolean(optionsPopoverAnchorElement)}
					anchorEl={optionsPopoverAnchorElement}
					onClose={() => this.handlePopoverClose(PopoverIds.OPTIONS)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<PopoverItem onClick={(e) => this.handlePopoverSelect(PopoverIds.OPTIONS, 'RENAME')}>
						<EditIcon /> Rename
					</PopoverItem>

					{!disableBucketDelete ? (
						<PopoverItem
							disabled={
								Object.keys(buckets).length &&
								optionsPopoverItem &&
								buckets[optionsPopoverItem] &&
								(buckets[optionsPopoverItem].pending_map_updates > 0 || buckets[optionsPopoverItem].mapped_dso.length > 0 || buckets[optionsPopoverItem].mapped_user.length > 0)
							}
							onClick={(e) => this.handlePopoverSelect(PopoverIds.OPTIONS, 'DELETE')}
							style={{ color: Theme.red }}
						>
							<TrashIcon /> Delete
						</PopoverItem>
					) :	null}
				</Popover>

				<Popover
					id={PopoverIds.SETTINGS}
					open={Boolean(settingsPopoverAnchorElement)}
					anchorEl={settingsPopoverAnchorElement}
					onClose={() => this.handlePopoverClose(PopoverIds.SETTINGS)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
				>
					<PopoverItem onClick={(e) => this.handlePopoverSelect(PopoverIds.SETTINGS, 'EDIT_PAYMENT_OPTIONS')}>
						<MoneyIcon style={{ marginRight: '8px', fontSize: '16px' }} /> Edit Payment Options
					</PopoverItem>

					<PopoverItem onClick={(e) => this.handlePopoverSelect(PopoverIds.SETTINGS, 'CHANGE_CREDIT_LIMIT')}>
						<CreditIcon style={{ marginRight: '8px', fontSize: '16px' }} /> Change Credit Limit
					</PopoverItem>

					<PopoverItem
						onClick={(e) => this.handlePopoverSelect(PopoverIds.SETTINGS, 'LOCK_ACCOUNT')}
						disabled={true}
					>
						<LockIcon style={{ marginRight: '8px', fontSize: '16px' }} /> Lock Account
					</PopoverItem>
				</Popover>

				<Popover
					id={PopoverIds.BUCKET}
					open={Boolean(bucketPopoverAnchorElement)}
					anchorEl={bucketPopoverAnchorElement}
					onClose={() => this.handlePopoverClose(PopoverIds.BUCKET)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
				>
					<PopoverTitle>Select Bucket</PopoverTitle>

					<PopoverItem>
						<Search
							searchText={bucketSearchText}
							placeholder={'Search Bucket'}
							searchOnChange={true}
							onSearchHandler={(value) => this.handleBucketSearchText(value)}
						/>
					</PopoverItem>

					<PopoverBody>
						{!bucketSearchText ? (
							<PopoverItem
								disabled={bucketPopoverItem && bucketPopoverItem.bucketId === 'none'}
								onClick={(e) => this.handlePopoverSelect(PopoverIds.BUCKET, 'none')}
							>
								None
							</PopoverItem>
						) : null}

						{bucketSearchText ? (
							filteredBuckets.length > 0 ? (
								filteredBuckets.map((bucket, index) => (
									<PopoverItem
										key={bucket}
										disabled={buckets[bucket] && buckets[bucket]?.pending_price_updates > 0}
										onClick={(e) => this.handlePopoverSelect(PopoverIds.BUCKET, bucket)}
									>
										{buckets[bucket]?.alias || ''}
									</PopoverItem>
								))
							) : (
								<NotFound line1="Couldn't find any items" />
							)
						) : Object.keys(buckets).length > 0 ? (
							Object.keys(buckets).map((bucket, index) => (
								<PopoverItem
									key={bucket}
									disabled={buckets[bucket] && buckets[bucket]?.pending_price_updates > 0}
									onClick={(e) => this.handlePopoverSelect(PopoverIds.BUCKET, bucket)}
								>
									{buckets[bucket]?.alias || null}
								</PopoverItem>
							))
						) : (
							<NotFound line1="Couldn't find any items" />
						)}
					</PopoverBody>
				</Popover>

				<TitleSection>
					<TitleRow responsive='1200px'>
						<FlexColumn style={{ flex: 'auto' }}>
							<FlexRow style={{ gap: '2rem', justifyContent: "space-between" }}>
								<Title>DSO Pricing</Title>

								<Search
									searchText={searchText}
									placeholder={'Search with DSO name'}
									enableDelayOnChange={true}
									searchOnChange={true}
									onSearchHandler={(value) => {
										this.handleSearchText(value);
									}}
								/>
							</FlexRow>
						</FlexColumn>

						<FlexColumn style={{ alignSelf: 'center' }}>
							<ButtonGroup alignRight>
								<SquareButton 
									secondary 
									onClick={(e) => {this.refreshInventoryData()}}
								>
									<RefreshInventoryIcon/>
								</SquareButton>	
							</ButtonGroup>
						</FlexColumn>
					</TitleRow>
				</TitleSection>

				<FlexRow>
					<FlexColumn>
						<Tabs>
							<Tab
								active={activeTab === 0}
								onClick={() => {
									this.setActiveTab(0);
								}}
							>
								Active DSOs
							</Tab>
							<Tab
								active={activeTab === 1}
								onClick={() => {
									this.setActiveTab(1);
								}}
							>
								Bucket Pricing
							</Tab>
						</Tabs>
					</FlexColumn>

					<FlexColumn style={{ marginLeft: 'auto' }}>
						<FlexRow align='flex-end'>
							<Note>All updates which require approval will reflect on Dentira website next business day if approved.</Note>
						</FlexRow>
					</FlexColumn>
				</FlexRow>

				{activeTab === 0 ? (
					<>
						<TableContainer>
							<Table>
								<TableHeader>
									<TableHeaderRow>
										<TableHeaderColumn style={{ width: '25%' }}>Name</TableHeaderColumn>

										<TableHeaderColumn style={{ width: '15%' }}>Primary Bucket</TableHeaderColumn>

										<TableHeaderColumn style={{ width: '15%' }}>Secondary Bucket</TableHeaderColumn>
										{this.props.isLabSeller ? null :
											<>
												<TableHeaderColumn style={{ width: '23%' }}>Payment Methods</TableHeaderColumn>

												<TableHeaderColumn style={{ width: '10%' }}>Credit Limit</TableHeaderColumn>

												<TableHeaderColumn
													alignRight
													style={{ width: '12%' }}
												>
													Actions
												</TableHeaderColumn>
											</>

										}
									</TableHeaderRow>
								</TableHeader>

								<TableBody>
									{dso && Object.keys(dso).length ? (
										Object.keys(dso).map((key, index) => {
											let item = dso[key];
											return (
												<TableRow key={index}>
													<TableColumn>
														<FlexRow>
															<DSOLogoContainer>
																{item.group_logo ? (
																	<DSOLogo
																		src={item.group_logo}
																		alt='Not Found'
																	/>
																) : (
																	<DSOAbbreviation>{abbreviateName(item.group_name)}</DSOAbbreviation>
																)}
															</DSOLogoContainer>
															<FlexColumn style={{ paddingLeft: '1rem' }}>
																<FlexRow>{item.group_name}</FlexRow>
															</FlexColumn>
														</FlexRow>
													</TableColumn>

													<TableColumn>
														{Object.keys(buckets).length ? (
															item.price_buckets[supplier] ? (
																Object.keys(item.price_buckets[supplier]).includes('primary_bucket_new') ? (
																	<Buckets 
																		disabled={true}
																		style={{color: Theme.red}}
																	>
																		{item.price_buckets[supplier].primary_bucket_new ? buckets[item.price_buckets[supplier].primary_bucket_new]?.alias || null : 'None'}
																	</Buckets>
																) : item.price_buckets[supplier].primary_bucket ? (
																	buckets[item.price_buckets[supplier].primary_bucket]?.pending_price_updates > 0 ? (
																		<Buckets 
																			disabled={true}
																			style={{color: Theme.red}}
																		>
																			{buckets[item.price_buckets[supplier].primary_bucket]?.alias || null}
																		</Buckets>
																	) : (
																		<Buckets
																			disabled={disableBucketAssigning}
																			onClick={(e) => {
																				if(!disableBucketAssigning){
																					this.setState({
																						bucketPopoverItem: {
																							dsoId: item._id,
																							source: 'primary_bucket',
																							bucketId: item.price_buckets[supplier].primary_bucket,
																						},
																					});
																					this.handlePopoverClick(PopoverIds.BUCKET, e);
																				}
																			}}
																		>
																			{buckets[item.price_buckets[supplier].primary_bucket]?.alias || null}
																			{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																		</Buckets>
																	)
																) : (
																	<Buckets
																		disabled={disableBucketAssigning}
																		onClick={(e) => {
																			if(!disableBucketAssigning){
																				this.setState({ bucketPopoverItem: { dsoId: item._id, source: 'primary_bucket', bucketId: 'none' } });
																				this.handlePopoverClick(PopoverIds.BUCKET, e);
																			}
																		}}
																	>
																		None
																		{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																	</Buckets>
																)
															) : (
																<Buckets
																	disabled={disableBucketAssigning}
																	onClick={(e) => {
																		if (!disableBucketAssigning) {
																			this.setState({ bucketPopoverItem: { dsoId: item._id, source: 'primary_bucket', bucketId: 'none' } });
																			this.handlePopoverClick(PopoverIds.BUCKET, e);
																		}
																	}}
																>
																	None
																	{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																</Buckets>
															)
														) : (
															'No Buckets'
														)}
													</TableColumn>

													<TableColumn>
														{Object.keys(buckets).length ? (
															item.price_buckets[supplier] ? (
																Object.keys(item.price_buckets[supplier]).includes('secondary_bucket_new') ? (
																	<Buckets
																		disabled={true}
																		style={{ color: Theme.red }}
																	>
																		{item.price_buckets[supplier].secondary_bucket_new ? buckets[item.price_buckets[supplier].secondary_bucket_new]?.alias || null : 'None'}
																	</Buckets>
																) : item.price_buckets[supplier].secondary_bucket ? (
																	buckets[item.price_buckets[supplier].secondary_bucket]?.pending_price_updates > 0 ? (
																		<Buckets
																			disabled={true} 
																			style={{ color: Theme.red }}
																		>
																			{buckets[item.price_buckets[supplier].secondary_bucket]?.alias || null}
																		</Buckets>
																	) : (
																		<Buckets
																			disabled={disableBucketAssigning}
																			onClick={(e) => {
																				if(!disableBucketAssigning){
																					this.setState({
																						bucketPopoverItem: {
																							dsoId: item._id,
																							source: 'secondary_bucket',
																							bucketId: item.price_buckets[supplier].secondary_bucket,
																						},
																					});
																					this.handlePopoverClick(PopoverIds.BUCKET, e);
																				}
																			}}
																		>
																			{buckets[item.price_buckets[supplier].secondary_bucket]?.alias || null}
																			{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																		</Buckets>
																	)
																) : (
																	<Buckets
																		disabled={disableBucketAssigning}
																		onClick={(e) => {
																			if(!disableBucketAssigning){
																				this.setState({ bucketPopoverItem: { dsoId: item._id, source: 'secondary_bucket', bucketId: 'none' } });
																				this.handlePopoverClick(PopoverIds.BUCKET, e);
																			}
																		}}
																	>
																		None
																		{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																	</Buckets>
																)
															) : (
																<Buckets
																	disabled={disableBucketAssigning}
																	onClick={(e) => {
																		if(!disableBucketAssigning){
																			this.setState({ bucketPopoverItem: { dsoId: item._id, source: 'secondary_bucket', bucketId: 'none' } });
																			this.handlePopoverClick(PopoverIds.BUCKET, e);
																		}
																	}}
																>
																	None
																	{!disableBucketAssigning ? <ArrowDownIcon /> : null}
																</Buckets>
															)
														) : (
															'No Buckets'
														)}
													</TableColumn>

													{this.props.isLabSeller ? null:<> <TableColumn>
														{item.supplier_config && item.supplier_config[supplier] && item.supplier_config[supplier].payment_methods
															? Object.keys(item.supplier_config[supplier].payment_methods).some((method, index) =>
																	item.supplier_config[supplier].payment_methods[method].is_active ? true : false
															  )
																? Object.keys(item.supplier_config[supplier].payment_methods).map((method, index) =>
																		item.supplier_config[supplier].payment_methods[method].is_active ? `${paymentMethods[method].name}, ` : null
																  )
																: '-'
															: '-'}
													</TableColumn>

													<TableColumn>
														{item.supplier_config && item.supplier_config[supplier] && item.supplier_config[supplier].credit && item.supplier_config[supplier].credit.limit
															? formatCurrency(item.supplier_config[supplier].credit.limit, true)
															: 'Not Set'}
													</TableColumn>

													<TableColumn
														alignRight
														style={{ color: Theme.orange }}
													>
														<span
															style={{ cursor: 'pointer' }}
															onClick={(e) => {
																this.setState({ settingsPopoverItem: item._id, settingsPopoverItemName: item.group_name });
																this.handlePopoverClick(PopoverIds.SETTINGS, e);
															}}
														>
															<SettingsIcon /> Settings
														</span>
													</TableColumn> </>}
												</TableRow>
											);
										})
									) : (
										<TableRow key='not-found'>
											<TableColumn colSpan={'100%'}>
												<NotFound lines={["No DSOs assigned"]} />
											</TableColumn>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>

						<TablePagination
							component='div'
							count={dsoState.totalResults ? dsoState.totalResults : 0}
							page={pageNumber}
							onPageChange={(e, page) => {
								this.setState({ pageNumber: parseInt(page, 10) });
							}}
							rowsPerPage={pageSize}
							onRowsPerPageChange={(e) => {
								this.setState({ pageSize: parseInt(e.target.value, 10) });
							}}
						/>
					</>
				) : null}

				{activeTab === 1 ? (
					<>
						<TableContainer>
							<Table>
								<TableHeader>
									<TableHeaderRow>
										<TableHeaderColumn style={{ width: '25%' }}>Name</TableHeaderColumn>

								{this.props.isLabSeller?null:<TableHeaderColumn style={{ width: '20%' }}>Mapped To Users</TableHeaderColumn>}

										<TableHeaderColumn style={{ width: '55%' }}>Mapped To DSOs</TableHeaderColumn>

										<TableHeaderColumn
											alignRight
											style={{ flex: 1 }}
										>
											Actions
										</TableHeaderColumn>
									</TableHeaderRow>
								</TableHeader>

								<TableBody>
									{buckets && Object.keys(buckets).length ? (
										Object.keys(buckets).map((key, index) => {
											let bucket = buckets[key];
											return (
												<TableRow key={bucket.id}>
													<TableColumn>
														<FlexRow>
															<FlexColumn style={{ lineHeight: '16px' }}>
																<FlexRow>{bucket.alias.toUpperCase()}</FlexRow>
																{bucket.pending_map_updates === 0 ? (
																	<FlexRow style={{ gap: '0.25rem', color: Theme.green, fontWeight: '400', fontSize: '11px' }}>Active</FlexRow>
																) : (
																	<FlexRow style={{ gap: '0.25rem', color: Theme.red, fontWeight: '400', fontSize: '11px' }}>
																		{`${bucket.pending_map_updates} ${bucket.pending_map_updates <= 1 ? `item` : `items`}`}
																		<DotIcon />
																		Waiting for approval
																	</FlexRow>
																)}
															</FlexColumn>
														</FlexRow>
													</TableColumn>

													{this.props.isLabSeller ? null :<TableColumn>
														{bucket?.mapped_user.length ? (
															<FlexRow style={{ gap: '0.5rem' }}>
																Yes
																<DotIcon />
																<span
																	style={{ color: Theme.orange }}
																	onClick={(e) => {
																		this.setState({ mappedUsersDialogOpen: true, mappedUsersDialogData: bucket.mapped_user });
																	}}
																>
																	View Users
																</span>
															</FlexRow>
														) : (
															<FlexRow>No</FlexRow>
														)}
													</TableColumn>}

													<TableColumn>
														<FlexRow>{bucket.mapped_dso.map((dso) => dso).join(', ')}</FlexRow>
													</TableColumn>

													<TableColumn alignRight>
														<MenuIcon
															style={{ cursor: 'pointer' }}
															onClick={(e) => {
																this.setState({ optionsPopoverItem: bucket.id });
																this.handlePopoverClick(PopoverIds.OPTIONS, e);
															}}
														/>
													</TableColumn>
												</TableRow>
											);
										})
									) : (
										<TableRow key='not-found'>
											<TableColumn colSpan={'100%'}>
												<NotFound
													line1="Couldn't find any items."
													line2='Start by adding new items in the inventory section.'
												/>
											</TableColumn>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
					</>
				) : null}
			</RootContainer>
		);
	}
}

const mapStateToProps = (state) => {
	let supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	let userSellerPortalConfig = state.session.sellerPortalConfig || {};

	let disableBucketAssigning = (supplierSellerPortalConfig.disable_bucket_assigning || userSellerPortalConfig.disable_bucket_assigning) || false;
	let disableBucketDelete = (supplierSellerPortalConfig.disable_bucket_delete || userSellerPortalConfig.disable_bucket_delete) || false;

	return {
		tile: state.tiles.tile,
		disableBucketAssigning,
		disableBucketDelete,
		supplier: state.supplier.supplier,
		bucketItems: state.inventory.bucketItems,
		dso: state.dso.dsoItems,
		isLabSeller: checkLabSeller(state?.session?.user_type)
	};
};

const mapDispatchToProps = {
	changeTile,
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
	fetchBucketList,
	fetchDSOList,
	mapDSO,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DSOPricing));
